/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, {useEffect, useState} from 'react';
import MapBase from "./MapBase";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {arrayToRgb, getApiUrl, getLastYear, numberWithCommas} from "../../utils";
import WidgetRadioStats from "./widgets/WidgetRadioStats";
import RMateChartSpecificRadio from "./r_mate_chart/RMateChartSpecificRadio";
import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYearMonth from "./widgets/WidgetSelectYearMonth";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import {WELL_KNOWN_POSITION} from "../../Constants";
import AlignRightText from "./widgets/AlignRightText";


function MapSpecificRadio() {

  const [fillColorLegend, setFillColorLegend] = useState([]);

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      year: getLastYear(),
      month: 12,
      currentDistrictCode: '',
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {properties: {pk, name}} = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = obj;
          return `<span class='fontStyle'>${name}</span><br/> 
                   간이무선국 수 : ${numberWithCommas(total)}개<br/>`;
        }
        return `<span class='fontStyle'>${name}</span><br/> 
                  간이무선국 수 : 0개<br/>`;
      },
      getLevelFillColor: ({properties: {pk}}, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = (metricObject[code] || {total: 1});
          if (total >= 1) {
            const index = Math.floor(PALETTE_YlOrRd_9.length * (total - 1) / metricMax);
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      frq_code_stats_list: ["100", "200", "400"],
      use_code_stats_list: ["PRTBL", "FIXING", "VHCLE"],
      display_code_stats: "01",
    }
  });

  const [statsJsonSearchCodeList, setStatsJsonSearchCodeList] =
    useState({
        frq_code: ["100", "200", "400"],
        use_code: ["PRTBL", "FIXING", "VHCLE"],
      }
    );

  /*
     서버 Ajax 통신을 위해 json을 만듭니다.
  */

  const settingChkRadSvcString = (checkList) => {
    // as-is 의 json 통신을 위한 문자열 만들기
    let JSONList = {
      "data": []
    };

    for (let value of checkList) {
      const jsonValue = {"CHK_VALUE": value};
      JSONList.data.push(jsonValue);
    }
    return JSON.stringify(JSONList);
  };
// 차트 색을 입히기 위해 라벨 array를 만듭니다.
  const settingLabelListforFrq = (frqList) => {

    let labelList = [];
    for (let frqCode of frqList) {
      if (frqCode === '100') labelList.push("100MHz대");
      else if (frqCode === '200') labelList.push("200MHz대");
      else if (frqCode === '400') labelList.push("400MHz대");
    }
    return labelList;
  };
  const settingLabelListforUse = (useList) => {

    let labelList = [];
    for (let useCode of useList) {
      if (useCode === 'PRTBL') labelList.push("휴대용");
      else if (useCode === 'FIXING') labelList.push("고정용");
      else if (useCode === 'VHCLE') labelList.push("차량용");
    }
    return labelList;
  };
  // --- 서버 통신을 위한 함수 끝

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    geojsonExtraParams,
    clickedPolygonGeojsonObjects,
    setGeojsonExtraParams,
    currentDistrictCode,
    setCurrentDistrictCode,
    setChartAjaxParams, chartAjaxParams,
  } = mapProps;


  useEffect(() => {
    const {
      frq_code_stats_list,
      use_code_stats_list
    } = widgetState;
    setStatsJsonSearchCodeList(
      {
        frq_code: frq_code_stats_list,
        use_code: use_code_stats_list,
      });
  }, [widgetState]);

  const {display_code_stats} = widgetState;
  useEffect(()=>{
    setChartAjaxParams({
      ...chartAjaxParams,
      cmb_gubun_chart: display_code_stats,
    })
  },[display_code_stats]);



  useEffect(() => {
    // String 조합
    let searchCodeList = [];

    /*
    code frq_code
    list (3) ["100", "200", "400"]
    code use_code
    list (3) ["PRTBL", "FIXING", "VHCLE"]
     */
    const frq_list = statsJsonSearchCodeList["frq_code"];
    const use_list = statsJsonSearchCodeList["use_code"];

    if (frq_list.length !== 0) {
      const frqCode = frq_list.map(code => code + ":");
      if (use_list.length !== 0) {
        let codeList = [];
        for (let useCode of use_list) {
          codeList = codeList.concat(frqCode.map(code => code + useCode));
        }
        searchCodeList = codeList;
      } else {
        searchCodeList = frqCode;
      }
    } else { // 주파수 대역 조건은 없고, 용도가 있는 경우 또는 용도도 없는 경우
      if (use_list.length !== 0) { // 주파수 없이 용도검색만 있는 경우
        searchCodeList = use_list
      } else { // 아예 없는 경우
      }
    }

    const codeList = searchCodeList;
    // 데이터리스트에서 맞는 문자열의 합 구하기
    const metricObject = {};
    if (dataResponseList.length > 0) {
      /*
      {11110: {100:PRTBL: 1441, 100:VHCLE: 7, 200:PRTBL: 973, 400:PRTBL: 7539, 400:VHCLE: 22},…}
        11110: {100:PRTBL: 1441, 100:VHCLE: 7, 200:PRTBL: 973, 400:PRTBL: 7539, 400:VHCLE: 22}
        100:PRTBL: 1441
        100:VHCLE: 7
        200:PRTBL: 973
        400:PRTBL: 7539
        400:VHCLE: 22
       */
      const firstDataLayer = dataResponseList[0];
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let total = 0;
        for (let [checkCode, stat] of Object.entries(stats)) {
          for (let search_code of codeList) {
            if (checkCode.includes(search_code)) {
              const codeVal = firstDataLayer[code][checkCode];
              total += codeVal;
            }
          }
        }
        metricObject[code] = {total};

      }
    }

    const metricMax = Math.max(...Object.values(metricObject).map(obj => obj.total));

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);

      ////////// ajax new_param 설정////////////
      // 연월 세팅
      const {year, month} = geojsonExtraParams;

      if (month < 10) {
        window.searchYear = year.toString() + '0' + month.toString();
      } else {
        window.searchYear = year.toString() + month.toString();
      }

      // 지역정보 표시 방법
      const {display_code_stats} = widgetState;

      // json 문자열
      window.chkString01 = settingChkRadSvcString(frq_list);
      window.chkString02 = settingChkRadSvcString(use_list);

      // 파라미터 배열
      // window.prm_check = frq_list;
      // window.prm_check2 = use_list;

      window.sidoCode = (currentDistrictCode || '').length < 2
        ? ''
        : currentDistrictCode.substr(0, 2);

      window.new_param =
        'sidoCode=' + window.sidoCode +
        '&searchYear=' + window.searchYear +
        '&chkString01=' + window.chkString01 +
        '&chkString02=' + window.chkString02;

      setChartAjaxParams({
        searchStart: window.searchYear,
        sidoCode: window.sidoCode,
        searchYear: window.searchYear,
        chkString01: settingChkRadSvcString(frq_list),
        chkString02: settingChkRadSvcString(use_list),
        prm_check : frq_list,
        prm_check_label : settingLabelListforFrq(frq_list),
        prm_check2 : use_list,
        prm_check2_label : settingLabelListforUse(use_list),
        cmb_gubun_chart: display_code_stats,
      })
    }
  }, [dataResponseList, widgetState, statsJsonSearchCodeList, geojsonExtraParams, currentDistrictCode]);

  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    } else { // 데이터가 없을때
      setFillColorLegend(
        [...Array(1).keys()].map(colorIndex => {
          const boundary = 0;
          const colorRgb = '#ffffd9';
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  const makeCodeName = (code) => {
    if(code === '01') return '주파수 대역별';
    if(code === '02') return '용도별';
    return code;
  };

  const makeColumns = (code) => {
    if(code === '01') { // 주파수 대역별
      return [
        {title: '지역', dataIndex: 'gugun', key: 'gugun', width: 170, fixed: 'left'},
        {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
        {title: '100MHz대', dataIndex: 'data_01_100_cnt', key: 'data_01_100_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
        {title: '200MHz대', dataIndex: 'data_01_200_cnt', key: 'data_01_200_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
        {title: '400MHz대', dataIndex: 'data_01_400_cnt', key: 'data_01_400_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
      ]
    } else { // 용도별
      return [
        {title: '지역', dataIndex: 'gugun', key: 'gugun', width: 170, fixed: 'left'},
        {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
        {title: '휴대용', dataIndex: 'data_02_prtbl_cnt', key: 'data_02_prtbl_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
        {title: '고정용', dataIndex: 'data_02_fixing_cnt', key: 'data_02_fixing_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
        {title: '차량용', dataIndex: 'data_02_vhcle_cnt', key: 'data_02_vhcle_cnt',
          render: value => AlignRightText({ text: value, numberComma: true })},
      ]
    }

  };

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideWidgetToggleClustering={true} isHideWidgetMapLayerTypes={true}>
        <WidgetContainer>
          <div>
            <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} onlyLv1={true} />
            <WidgetSelectYearMonth/>
            <Seperator/>
            <WidgetRadioStats/>
          </div>
        </WidgetContainer>
      </MapBase>
      <WidgetRisingTabs titleOnInit={[`${makeCodeName(display_code_stats)} 지역별 간이무선국 현황`, `${makeCodeName(display_code_stats)} 간이무선국 현황`]}>
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type3"})}
          type={"type3"}
          getTitle={(layer) => `${makeCodeName(display_code_stats)}  지역별 간이무선국 현황`}
          columns={makeColumns(display_code_stats)}
        />
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type1"})}
          type={"type1"}
          getTitle={(layer) => `${display_code_stats === '01'? '주파수 대역별': display_code_stats === '02'? '용도별': display_code_stats} 간이무선국 현황`}
          processor={objectList => {
            const rowList = objectList.filter(({data_type}) => {
              if(display_code_stats === '01') {
                return data_type === 'DATA_TYPE1'
              } else if(display_code_stats === '02') {
                return data_type === 'DATA_TYPE2'
              } else {
                return false;
              }
            }).map(item => (item.data_type === 'DATA_TYPE2'? {...item, data_comment : '용도별 간이무선국 현황'} : item));
            const columns = [];
            return [columns, rowList];
          }}
          columns={
            // (currentPageData) => (
              [
            {title: '구분', dataIndex: 'data_comment', key: 'data_comment', width: 210, fixed: 'left',
              // render: makeRowSpanRender({ columnName: 'data_comment', currentPageData})
            },
            {title: '구분명', dataIndex: 'data_name', key: 'data_name'},
            {title: '무선국 수', dataIndex: 'data_cnt', key: 'data_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })
            },
          ]
            // )
          }
        />
      </WidgetRisingTabs>

      <RMateChartSpecificRadio disabled={
        (widgetState.frq_code_stats_list.length === 0) ||
        (widgetState.use_code_stats_list.length === 0)
      }/>
      {fillColorLegend.length > 0 && <WidgetLegend fillColorLegend={fillColorLegend}  titleColorLegend={'무선국 수'}  unitColorLegend={'개'}/>}
      <WidgetToolbar/>
    </MapPropsProvider>
  );
}

export default MapSpecificRadio;
